import Spinner from 'src/javascripts/components/utilities/Spinner';

export default class SurveysSectionsQuestionGroupsIndex {

  constructor() {}

  render() {

    // Draggable sections https://api.jqueryui.com/sortable
    $('.question-groups-sortable').sortable({
      placeholder: "available-section-space",
      cursor: "move",
      handle: ".grip",
      items: "li.question-group-row",
      update: function(event, ui) {
        let sortOrder = $(this).sortable('toArray');
				let accountUrl = $('body').attr('data-account-url');
				let surveySlug = $(this).attr('data-slug');
        let sectionId = $(this).attr('data-section-id');
        let url = '/' + accountUrl + '/surveys/' + surveySlug + '/sections/' + sectionId + '.json?';
        let params = {};
	      params['survey_section'] = {};
	      params['survey_section']['question_groups_attributes'] = {};
        $.each(sortOrder, function(ind, sectionId) {
          let id = $('#' + sectionId).attr('data-id');
	        params['survey_section']['question_groups_attributes'][ind] = {};
	        params['survey_section']['question_groups_attributes'][ind]['id'] = id;
	        params['survey_section']['question_groups_attributes'][ind]['sort_order'] = ind + 1;
        });
        $.ajax({
          type: 'PATCH',
          dataType: 'application/json',
          url: url + $.param(params),
          complete(result) { 
            let responseText = JSON.parse(result.responseText);
          },
        });
      }
    });

    // Draggable sections https://api.jqueryui.com/sortable
    $('.questions-sortable').sortable({
      placeholder: "available-question-space",
      cursor: "move",
      handle: ".grip",
      items: "li.question-row:not(.unsortable)",
      update: function(event, ui) {
        let sortOrder = $(this).sortable('toArray');
        let accountUrl = $('body').attr('data-account-url');
        let surveySlug = $(this).attr('data-slug');
        let sectionId = $(this).attr('data-section-id');
        let questionGroupId = $(this).attr('data-question-group-id');
        let url = '/' + accountUrl + '/surveys/' + surveySlug + '/sections/' + sectionId + '/question_groups/' + questionGroupId + '.json?';
        let params = {};
        params['survey_question_group'] = {};
        params['survey_question_group']['questions_attributes'] = {};
        params['survey_question_group']['contents_attributes'] = {};
        params['survey_question_group']['tables_attributes'] = {};
        $.each(sortOrder, function(ind, sectionId) {
          let c = $('#' + sectionId).attr('data-class-name');
          let id = $('#' + sectionId).attr('data-id');
          if (c === 'Survey::Question') {
            params['survey_question_group']['questions_attributes'][ind] = {};
            params['survey_question_group']['questions_attributes'][ind]['id'] = id;
            params['survey_question_group']['questions_attributes'][ind]['sort_order'] = ind + 1;
          } else if (c === 'Survey::Content') {
            params['survey_question_group']['contents_attributes'][ind] = {};
            params['survey_question_group']['contents_attributes'][ind]['id'] = id;
            params['survey_question_group']['contents_attributes'][ind]['sort_order'] = ind + 1;
          } else if (c === 'Survey::Table') {
            params['survey_question_group']['tables_attributes'][ind] = {};
            params['survey_question_group']['tables_attributes'][ind]['id'] = id;
            params['survey_question_group']['tables_attributes'][ind]['sort_order'] = ind + 1;            
          }
        });

        $.ajax({
          type: 'PATCH',
          dataType: 'application/json',
          url: url + $.param(params),
          complete(result) { 
            let responseText = JSON.parse(result.responseText);
          },
        });
      }
    });


  }

}